var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.display, _vm.justifyText, 'items-center']},[_c('h1',{staticClass:"font-semibold",class:[_vm.fontSize, _vm.position]},[_vm._t("default")],2),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }